/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
/**
 * NOTE: using traditional object notation with prototype is not possible, because diretives are not managed as
 * object instances, simply as standalone function containers. They are not considered
 * as stateful objects (at least the call of their functions is made in a procedural way, no scoping).
 */
/** @ngInject */
function PermissionExceptFactory($log, authenticationService) {
    const permission = {
        restrict: 'A'
    };

    /**
     * Checks if the user is authenticated and has the roles given in the attribute 'permission-except'. The attribute
     * supports the following syntax:
     * <ul>
     * <li>permission-except="ADMIN" => checks if the user has not the ADMIN role.</li>
     * <li>permission-except="'ADMIN'" => checks if the user has not the ADMIN role.</li>
     * <li>permission-except="['ADMIN', 'USER']" => checks if the user has not the ADMIN or the USER role.</li>
     * </ul>
     * The element is removed from the DOM tree if the user is authenticated and has one of the specified role.
     *
     * @param {Object} scope Directive' scope.
     * @param {DOMElement} element DOM element the 'permission-except' attribute is applied on.
     * @param {Object} attributes Attributes in the previous element.
     */
    permission.link = function(scope, element, attributes) {
        if (attributes.permissionExcept) {
            let roles;
            if (attributes.permissionExcept.startsWith('\'') || attributes.permissionExcept.startsWith('[')) {
                roles = scope.$eval(attributes.permissionExcept);
            } else {
                roles = attributes.permissionExcept;
            }
            if (angular.isString(roles)) {
                roles = [roles];
            }
            if (angular.isArray(roles) && authenticationService.userHasRole(roles)) {
                element.remove();
            }
        }
    };

    $log.debug('Factory \'PermissionExcept\' loaded');
    return permission;
}

export { PermissionExceptFactory };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/security/component/PermissionExcept.js